// Rich-text segments for the landing page's search bar placeholder and "not sure where to
// start?" template suggestions. A plain string renders as-is; { pill: "..." } renders as a
// highlighted term (see components/search/HighlightedText.js).

export const searchPlaceholderSegments = [
  "Search any combination of ",
  { pill: "people" },
  " ",
  { pill: "perspectives" },
  " and ",
  { pill: "places" },
  " by ",
  { pill: "geography level" },
];

export const startTemplates = [
  {
    query: "Local Voter Score in state house districts in Missouri and Arkansas",
    segments: [
      "What does the ",
      { pill: "Local Voter Score" },
      " look like in state house districts in ",
      { pill: "Missouri" },
      " and ",
      { pill: "Arkansas" },
    ],
  },
  {
    query: "racial makeup of voters ages 25-40 in Pinellas County, Florida",
    segments: [
      "Racial makeup of voters ",
      { pill: "Ages 25-40" },
      " in ",
      { pill: "Pinellas County, Florida" },
    ],
  },
  {
    query: "married male voters in Georgia by county",
    segments: [
      "How many ",
      { pill: "Married" },
      " ",
      { pill: "Male" },
      " voters are there in ",
      { pill: "Georgia" },
      " by ",
      { pill: "County" },
      "?",
    ],
  },
  {
    query: "demographic breakdown of ranked choice voting supporters in Los Angeles",
    segments: [
      "What is the demographic breakdown of ranked choice voting supporters in ",
      { pill: "Los Angeles" },
      "?",
    ],
  },
  {
    query: "voter turnout numbers in Tulsa and Oklahoma City by zip",
    segments: [
      "Voter turnout numbers in ",
      { pill: "Tulsa" },
      " and ",
      { pill: "Oklahoma City" },
      " by ",
      { pill: "Zip" },
    ],
  },
  {
    query: "Gun Control Score for Independent voters in Ohio by state upper house district",
    segments: [
      "What is the ",
      { pill: "Gun Control Score" },
      " for ",
      { pill: "Independent" },
      " voters in ",
      { pill: "Ohio" },
      " by ",
      { pill: "State Upper House" },
      " district?",
    ],
  },
  {
    query: "abortion support among single female voters in Texas by state lower house district",
    segments: [
      "What does abortion support look like among ",
      { pill: "Single" },
      " ",
      { pill: "Female" },
      " voters in ",
      { pill: "Texas" },
      " broken down by ",
      { pill: "State Lower House" },
      " district",
    ],
  },
  {
    query: "Municipal Turnout Score for Hispanic female voters in New York by congressional district",
    segments: [
      "By ",
      { pill: "Congressional District" },
      ", what is the ",
      { pill: "Municipal Turnout Score" },
      " for ",
      { pill: "Hispanic" },
      " ",
      { pill: "Female" },
      " voters in ",
      { pill: "New York" },
      "?",
    ],
  },
  {
    query: "Partisan Score for Democrat voters in Cook County, Illinois",
    segments: [
      "What is the ",
      { pill: "Partisan Score" },
      " for ",
      { pill: "Democrat" },
      " voters in ",
      { pill: "Cook County, Illinois" },
      "?",
    ],
  },
  {
    query: "racial makeup of suburban voters ages 18-24 in Wake County, North Carolina",
    segments: [
      "Racial makeup of ",
      { pill: "Suburban Less Dense" },
      " voters ",
      { pill: "Ages 18-24" },
      " in ",
      { pill: "Wake County, North Carolina" },
    ],
  },
];
